import { api, formHeaders } from "@";
import type { SearchValues, ThemeFormValues } from "../types";

// NOTE: Backend endpoints don't exist yet. Paths follow the projects-feature
// convention so the FE compiles and can be swapped over once the API lands.

export const getThemes = (
  page: number,
  perSize: number,
  search: Partial<SearchValues>,
) => {
  return api.get(
    `/api/AdminTheme/themes?page=${page}&perSize=${perSize}&title=${search.title || ""}&isPublished=${search.isPublished || ""}`,
  );
};

export const getTheme = (id: number | string) =>
  api.get(`/api/AdminTheme/themes/${id}`);

// Proxy endpoint: the server fetches the `.liquid` file at `url` and returns
// its raw content — used by the preview popup so we don't hit CORS on the
// storage/CDN host from the browser.
export const getThemeContentByUrl = (url: string) =>
  api.get(`/api/AdminTheme/themes/proxy`, { params: { url } });

export const togglePublished = (id: number, value: boolean) =>
  api.put(
    `/api/AdminTheme/themes/${id}/change-publish-status?isPublished=${value}`,
  );

export const deleteTheme = (id: number | string) =>
  api.delete(`/api/AdminTheme/themes/${id}`);

export const saveTheme = (data: ThemeFormValues) => {
  console.log("Saving theme with data:", data);
  const payload = {
    thumbnail: data.thumbnail,
    title: data.title,
    themeContent: data.themeContent,
    isPublished: data.isPublished,
    isActive: true,
  };

  if (data.id) {
    return api.put(`/api/AdminTheme/themes/${data.id}`, payload, formHeaders);
  }
  return api.post("/api/AdminTheme/themes", payload, formHeaders);
};
